import {NgModule} from '@angular/core';
import {ArticleSliderComponent} from "@iw-shop/article/components/slider/article-slider.component";
import {ArticlePriceComponent} from "@iw-shop/article/components/prices/price/article-price.component";
import {ArticleBasePriceComponent} from "@iw-shop/article/components/prices/price-basic/article-price-basic.component";
import {
    ArticlePriceQuantityDiscountButtonComponent
} from "@iw-shop/article/components/prices/quantity-discount-button/quantity-discount-button.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ArticleRatingComponent} from "@iw-shop/article/components/rating/article-rating.component";
import {AsyncPipe, DatePipe, JsonPipe, NgClass, NgForOf, NgIf, NgTemplateOutlet} from "@angular/common";
import {CarouselModule} from "primeng/carousel";
import {
    ArticleGalleryTemplateComponent
} from "@iw-shop/article/components/templates/gallery/article-gallery-template.component";
import {PopoverModule} from "primeng/popover";
import {MyFormsModule} from "@iw-shop/forms/my-forms.module";
import {RouterLink} from "@angular/router";
import {ArticleCartButtonComponent} from "@iw-shop/article/components/cart-button/article-cart-button.component";
import {ArticleNotificationComponent} from "@iw-shop/article/components/notification/article-notification.component";
import {
    ArticleFavoriteButtonComponent
} from "@iw-shop/article/components/favorite-button/article-favorite-button.component";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {CoreModule} from "@iw-shop/core/core.module";
import {ArticleListTemplateComponent} from "@iw-shop/article/components/templates/list/article-list-template.component";
import {ArticleMenuGroupsComponent} from "@iw-shop/article/components/menu-groups/article-menu-groups.component";
import {CdkDragHandle} from "@angular/cdk/drag-drop";
import {ContactModule} from "@iw-shop/contact/contact.module";
import {Tooltip} from "primeng/tooltip";

@NgModule({
    declarations: [
        ArticleSliderComponent,
        ArticlePriceComponent,
        ArticleBasePriceComponent,
        ArticlePriceQuantityDiscountButtonComponent,
        ArticleRatingComponent,
        ArticleGalleryTemplateComponent,
        ArticleListTemplateComponent,
        ArticleCartButtonComponent,
        ArticleNotificationComponent,
        ArticleFavoriteButtonComponent,
        ArticleMenuGroupsComponent
    ],
    imports: [
        ReactiveFormsModule,
        FormsModule,
        NgIf,
        CarouselModule,
        PopoverModule,
        MyFormsModule,
        RouterLink,
        FontAwesomeModule,
        CoreModule,
        CdkDragHandle,
        AsyncPipe,
        DatePipe,
        NgClass,
        NgTemplateOutlet,
        NgForOf,
        JsonPipe,
        ContactModule,
        Tooltip
    ],
    exports: [
        ArticleSliderComponent,
        ArticlePriceComponent,
        ArticleBasePriceComponent,
        ArticlePriceQuantityDiscountButtonComponent,
        ArticleRatingComponent,
        ArticleGalleryTemplateComponent,
        ArticleListTemplateComponent,
        ArticleCartButtonComponent,
        ArticleCartButtonComponent,
        ArticleNotificationComponent,
        ArticleFavoriteButtonComponent,
        ArticleMenuGroupsComponent
    ]
})
export class ArticleModule {
}
